import styled from 'styled-components/macro';

export const Container = styled.div`
  border-radius: 4px;
  border: 2px solid ${({ theme }) => theme.color.gray[200]};
  > div {
    padding: 1rem 0.3rem;
  }
`;
